import { EventRegistrationQuestionBase, EventSelectedRegistrationQuestion } from "../types/RegistrationQuestion";
import { deleteData, getData, postData, putData } from "./apiService";

export const getEventSelectedRegistrationQuestions = async (event_id: string): Promise<EventSelectedRegistrationQuestion[]> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData(`/events/${event_id}/event-selected-registration-questions`, {});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data as EventSelectedRegistrationQuestion[];  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch questions:', error);
      return [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };


  export const addSelectedQuestionsToEvent = async (event_id: string, questions: EventRegistrationQuestionBase[]): Promise<boolean> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await postData('/event-selected-registration-questions/set', {event_id: event_id, questions: questions});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch questions:', error);
      return false;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const addSelectedQuestionToEvent = async (event_id: string, question: EventRegistrationQuestionBase): Promise<boolean> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await postData('/event-selected-registration-questions', {event_id: event_id, is_required: question.is_required, preset_registration_question_id: question.preset_registration_question_id});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch questions:', error);
      return false;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };


export const updateEventSelectedRegistrationQuestion = async (
  event_id: string,
  question: EventSelectedRegistrationQuestion
): Promise<boolean> => {
  try {
    const response = await putData(`/events/${event_id}/event-selected-registration-questions/${question.preset_registration_question_id}`, {
      is_required: question.is_required
    });
    return response.data;
  } catch (error) {
    console.error('Failed to update selected registration question:', error);
    return false;
  }
};


export const deleteEventSelectedRegistrationQuestion = async (
  event_id: string,
  preset_selected_registration_question_id: string
): Promise<boolean> => {
  try {
    const response = await deleteData(`/events/${event_id}/event-selected-registration-questions/${preset_selected_registration_question_id}`, {});
    return response.data;
  } catch (error) {
    console.error('Failed to delete selected registration question:', error);
    return false;
  }
};
